@if (!room) {
<div class="chat-conversation-empty">
  Selecciona una sala para empezar a chatear, o crea una nueva.
</div>
} @else {
<div class="chat-conversation-header">
  <button type="button" class="chat-conversation-back" (click)="back.emit()" title="Volver a las salas" aria-label="Volver a las salas">
    <i class="fa-solid fa-arrow-left" aria-hidden="true"></i>
  </button>
  <div class="chat-conversation-title-group">
    @if (editingTitle) {
    <div class="chat-conversation-title-edit">
      <input
        type="text"
        class="form-control form-control-sm"
        [(ngModel)]="editingTitleText"
        [disabled]="savingTitle"
        (keydown.enter)="saveTitle()"
        (keydown.escape)="cancelEditTitle()"
      />
      <button type="button" class="btn-link-action" [disabled]="!editingTitleText.trim() || savingTitle" (click)="saveTitle()">{{ savingTitle ? 'Guardando...' : 'Guardar' }}</button>
      <button type="button" class="btn-link-action" [disabled]="savingTitle" (click)="cancelEditTitle()">Cancelar</button>
    </div>
    } @else {
    <span class="chat-conversation-title">
      @if (room.IsDefaultTitle && room.Members.length > 0) {
      @for (member of room.Members; track member.IdUser; let last = $last) {
      <span class="presence-dot" [class.online]="chatRealtimeService.isOnline(member.IdUser)" aria-hidden="true"></span>{{ member.Name }}@if (!last) {, }
      }
      } @else {
      {{ room.Title }}
      }
    </span>
    @if (room.IsAdmin) {
    <button type="button" class="btn-link-action" (click)="startEditTitle()" title="Editar nombre de la sala">
      <i class="fa-solid fa-pen"></i>
    </button>
    }
    }
  </div>
  <div class="chat-conversation-actions">
    <button type="button" class="btn-outline-black btn-sm" (click)="openManageMembers()">Miembros</button>
    @if (room.CanLeave) {
    <button type="button" class="btn-outline-black btn-sm" (click)="leaveRoom()">Salir</button>
    }
  </div>
</div>

<div class="chat-conversation-body" #messagesContainer (scroll)="onScroll()">
  @if (loadingOlder) {
  <div class="chat-loading-older">Cargando mensajes anteriores...</div>
  }

  @for (message of messages; track message.IdMessage; let i = $index) {
  @if (isNewDay(i)) {
  <div class="chat-day-separator"><span>{{ dateSeparatorLabel(message.CreationDate) }}</span></div>
  }
  <div class="chat-message" [class.is-mine]="message.IsMine">
    @if (!message.IsMine) {
    <div class="chat-message-sender">
      @if (message.IdUser) {
      <span class="presence-dot" [class.online]="chatRealtimeService.isOnline(message.IdUser)" aria-hidden="true"></span>
      }
      {{ message.SenderName }}
    </div>
    }

    @if (editingMessageId === message.IdMessage) {
    <div class="chat-message-edit">
      <input
        type="text"
        class="form-control form-control-sm"
        [(ngModel)]="editingText"
        (keydown.enter)="saveEdit(message)"
        (keydown.escape)="cancelEdit()"
      />
      <div class="chat-message-edit-actions">
        <button type="button" class="btn-link-action" [disabled]="!editingText.trim()" (click)="saveEdit(message)">Guardar</button>
        <button type="button" class="btn-link-action" (click)="cancelEdit()">Cancelar</button>
      </div>
    </div>
    } @else {
    @if (message.Message) {
    <div class="chat-message-bubble" [class.is-deleted]="message.IsDeleted" [class.is-system]="message.IsSystem">{{ message.Message }}</div>
    }
    @if (message.FileAttached && !message.IsDeleted) {
    <div class="chat-message-attachment">
      @if (isImageFile(message.FileAttached)) {
      <a role="button" class="image-link" (click)="openPreviewModal(message.FileAttached.FileName, message.FileAttached.FileUri, message.FileAttached.FileSize)">
        <img [src]="message.FileAttached.FileUri" [alt]="message.FileAttached.FileName" class="attachment-preview-image" (load)="onImageLoaded()" />
      </a>
      <a [href]="message.FileAttached.FileUri" target="_blank" class="attachment-link">
        <span class="file-name">{{ message.FileAttached.FileName }}</span>
        <span class="file-size">({{ formatFileSize(message.FileAttached.FileSize) }})</span>
      </a>
      } @else {
      <a [href]="message.FileAttached.FileUri" target="_blank" class="attachment-link">
        <i class="fa-solid fa-paperclip"></i>
        <span class="file-name">{{ message.FileAttached.FileName }}</span>
        <span class="file-size">({{ formatFileSize(message.FileAttached.FileSize) }})</span>
      </a>
      }
    </div>
    }
    <div class="chat-message-footer">
      <span class="chat-message-date">{{ message.CreationDate | date: 'HH:mm' }}</span>
      @if (message.IsAudio && !message.IsDeleted) {
      <i class="fa-solid fa-microphone chat-message-voice-icon" title="Mensaje transcrito por voz" aria-hidden="true"></i>
      }
      @if (message.IsEdited && !message.IsDeleted) {
      <span class="chat-message-edited">(editado)</span>
      }
      @if (message.IsMine && !message.IsDeleted) {
      <span class="chat-message-read" [class.is-read-all]="message.IsReadByAll" title="{{ message.IsReadByAll ? 'Visto por todos' : 'Enviado' }}">✓✓</span>
      }
      @if (message.IsMine && !message.IsDeleted && room.IsActiveMember) {
      <button type="button" class="btn-link-action" (click)="startEdit(message)">Editar</button>
      <button type="button" class="btn-link-action" (click)="confirmDeleteMessage(message)">Borrar</button>
      }
    </div>
    }
  </div>
  }

  <!-- Llegó algo nuevo mientras se leía más arriba (CHAT_REVISION.md B10). Sticky al fondo del área visible. -->
  @if (hasNewBelow) {
  <button type="button" class="btn-lead btn-sm chat-new-messages-button" (click)="goToNewMessages()">Nuevos mensajes ↓</button>
  }
</div>

@if (!room.IsActiveMember) {
<div class="chat-conversation-readonly-notice">Ya no perteneces a esta sala. Puedes leer la conversación hasta el momento en que la dejaste, pero no puedes escribir en ella.</div>
} @else {

@if (selectedFile) {
<div class="chat-selected-file">
  <i class="fa-solid fa-paperclip"></i>
  <span class="file-name">{{ selectedFile.name }}</span>
  <span class="file-size">({{ formatFileSize(selectedFile.size) }})</span>
  <button type="button" class="btn-link-action" (click)="removeSelectedFile()">Quitar</button>
</div>
}

<div class="chat-conversation-input">
  <input
    #fileInput
    type="file"
    class="chat-file-input-hidden"
    (change)="onFileSelected($event)"
  />
  <button type="button" class="btn-outline-black btn-sm" [disabled]="sending" (click)="triggerFileInput()">Adjuntar archivo</button>
  <input
    type="text"
    class="form-control"
    placeholder="Escribe un mensaje..."
    [(ngModel)]="newMessage"
    (keydown.enter)="send()"
  />
  @if (voiceSupported) {
  <button type="button" class="btn-outline-black btn-sm" title="Enviar un mensaje de voz" [disabled]="sending || voiceState !== 'idle'" (click)="startVoiceRecording()">
    <i class="fa-solid fa-microphone"></i>
  </button>
  }
  <button type="button" class="btn-lead" [disabled]="(!newMessage.trim() && !selectedFile) || sending || voiceState !== 'idle'" (click)="send()">Enviar</button>
</div>
}
}

<!-- Mensaje de voz (WHISPER.md §5): pantalla bloqueada. Preparando: un clic cancela. Grabando: un clic
     en cualquier sitio para y envía. Transcribiendo: no admite clics, solo informa. -->
@if (voiceState !== 'idle') {
<div class="chat-voice-overlay" [class.is-clickable]="voiceState === 'preparing' || voiceState === 'recording'" (click)="onVoiceOverlayClick()">
  <div class="chat-voice-box">
    @switch (voiceState) {
    @case ('preparing') {
    <div class="spinner-border chat-voice-spinner" role="status" aria-hidden="true"></div>
    <div class="chat-voice-title">Preparando micrófono...</div>
    <div class="chat-voice-hint">Espera a que ponga "Grabando" para hablar · Clic para cancelar</div>
    }
    @case ('recording') {
    <i class="fa-solid fa-microphone chat-voice-icon"></i>
    <div class="chat-voice-title">Grabando</div>
    <div class="chat-voice-timer">{{ voiceSeconds }}s</div>
    <div class="chat-voice-hint">Haz clic en cualquier sitio para enviar</div>
    }
    @default {
    <div class="spinner-border chat-voice-spinner" role="status" aria-hidden="true"></div>
    <div class="chat-voice-title">Transcribiendo...</div>
    }
    }
  </div>
</div>
}

<!-- Preview de imagen a tamaño grande, mismo patrón que incidence-message-list de sim-issue-tracker -->
<ng-template #previewModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Previsualización</h4>
    <button type="button" class="btn-close" aria-label="Cerrar" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="attachment-preview-modal-image-wrapper">
      <img [src]="previewFileUri" [alt]="previewFileName" class="attachment-preview-modal-image" />
    </div>
    <a [href]="previewFileUri" target="_blank" class="attachment-link">
      <span class="file-name">{{ previewFileName }}</span>
      <span class="file-size">({{ formatFileSize(previewFileSize) }})</span>
    </a>
  </div>
</ng-template>
